import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DocumentLibraryConstants } from '../document-library-constants';
import { DocumentPreviousPhase } from '../models/documentPreviousPhase';
import { DocumentDetail } from '../models/documentVersionDetail';
import { DocumentService } from '../services/document.service';
import { DocumentDetailDto } from '../../shared/models/document-details-dto';
import { DocumentFormattedFile } from '../models/DocumentFormattedFile';
import { DocumentFormattedFileEdit } from '../models/DocumentFormattedFileEdit';
import { catchError, throwError } from 'rxjs';


@Component({
  selector: 'app-document-reason-for-change-modal',
  templateUrl: './document-reason-for-change-modal.component.html',
  styleUrls: ['./document-reason-for-change-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentReasonForChangeModalComponent implements OnInit {
  @Input() documentDetailsDto!: DocumentDetailDto;
  @Output() isReasonForChangeModalVisible=new EventEmitter<boolean>();
  number!: string;
  documentPreviousPhase!: DocumentPreviousPhase;
  documentDetails!: DocumentDetail;
  previousPhase!: number;
  reasonForChange!: string;
  valueField: string = 'value';
  labelField: string = 'name';
  documentBindData: any = [];
  documentPhasesData: any = [];
  mandatoryFields = this.getDefaultMandatoryFields();
  documentPhasesWithOutPreviousPhase = [0, 6, 7, 8, 9];
  errorMessages: string[] = [];
  documentFormattedFile !: DocumentFormattedFile;
  documentFormattedFileEdit !: DocumentFormattedFileEdit;
   @Output() setDocumentDetailsLoader = new EventEmitter<any>();
  
  constructor(private router: Router, private documentsService: DocumentService, private messageService: MessageService) {
  }


  ngOnInit(): void {
    var url = this.router.url;
    var urlParts = this.router.parseUrl(url);
    this.number = urlParts.queryParams['number'];
    this.initialize();
  }

  display: boolean = true;

  initialize() {
    if (this.documentPhasesWithOutPreviousPhase.indexOf(Number(this.documentDetailsDto.phase)) === -1) {
      this.documentsService.getPhases(Number(this.documentDetailsDto.phase),this.documentDetailsDto.includeQAReview, this.documentDetailsDto.includesClientSignature).subscribe(
        serviceData => {
          this.documentPhasesData = serviceData;
        }
      );
    }
  }


  reloadDocumentDetail() {
    this.isReasonForChangeModalVisible.emit(false);
  }

  getDefaultMandatoryFields() {
    return {
      previousPhase: false,
      reasonForChange: false,
    }
  }

  saveReasonForChange() {
  this.errorMessages=[];
   this.validatePreviousPhaseModalControls();
   if(this.errorMessages.length === 0){
    this.documentPreviousPhase = {
      reason: this.reasonForChange,
      phase: this.previousPhase
    }
    this.documentsService.moveDocumentToPreviousPhase(this.documentDetailsDto.number, Number(this.documentDetailsDto.version), this.documentPreviousPhase)
    .pipe(
      catchError((err) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${err.error}`,
        });
        return throwError(() => err);
      })
    )  
    .subscribe(
        (serviceData) => {
          this.reloadDocumentDetail();
          this.display = false;
      });
    }
    
  }
  private validatePreviousPhaseModalControls(){
    const isWhitespace = (this.reasonForChange || '').trim().length === 0;
    if(this.reasonForChange === "" || this.reasonForChange === undefined || this.reasonForChange?isWhitespace:null){
          this.mandatoryFields.reasonForChange = true;
          this.errorMessages.push(DocumentLibraryConstants.PreviousPhase_ReasonForChange_Required); 
    }
    if(this.previousPhase === null|| this.previousPhase === undefined){
    this.mandatoryFields.previousPhase = true;
    this.errorMessages.push(DocumentLibraryConstants.PreviousPhase_Phase_Required);        
    }
  }

}
